import React, { useContext, useState } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import {
  MainContainer,
  WelcomeUser,
  Navbar,
  NavbarButton,
  StopShowCheckBox,
} from './welcomeOnboardingStyle.js';
import CloseButton from '../Buttons/CloseButton/index.jsx';
import StartOnboarding from './StartOnboarding.jsx';
import TutorialOnboarding from './TutorialOnboarding.jsx';
import { getUserName } from '../../userLocalDetails.js';
import WhatIsJeddAi from './WhatIsJeddAi.jsx';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { AppContext } from '../../app.context.js';
import { disableOnboarding, reenableOnboarding } from '../../service.js';
import CheckboxBordered from '../../components/CheckboxBordered/index.jsx';

const WelcomeOnboarding = ({ profile }) => {
  const navItems = ['Start', 'Tutorials', 'What is JeddAI?'];
  const [activeOnboarding, setActiveOnboarding] = useState('Start');
  const { closeWelcomeOnboarding } = useContext(AppContext);
  // Controlled so the box reflects the SERVER state, not an optimistic flip:
  // previously it toggled instantly and, if the API rejected, silently desynced
  // (the box reverted on the next load with no explanation).
  const [stopShowing, setStopShowing] = useState(false);
  const [togglePending, setTogglePending] = useState(false);

  const handleActiveOnboarding = () => {
    switch (activeOnboarding) {
      case 'Tutorials':
        return <TutorialOnboarding />;
      case 'What is JeddAI?':
        return <WhatIsJeddAi />;
      case 'Start':
      default:
        return <StartOnboarding onCloseOnboarding={closeWelcomeOnboarding} />;
    }
  };

  const handleStopShowingToggle = async (e) => {
    const next = e.target.checked;
    if (togglePending) return;
    setTogglePending(true);
    try {
      if (next) {
        await disableOnboarding();
      } else {
        await reenableOnboarding();
      }
      setStopShowing(next); // only reflect it once the server confirmed
    } catch (error) {
      console.error(error);
      toast("Couldn't update that — please try again.");
      // leave stopShowing unchanged so the box snaps back to the server truth
    } finally {
      setTogglePending(false);
    }
  };

  return (
    <Dialog
      open={true}
      maxWidth={false}
      sx={{
        '& .MuiDialog-paper': {
          width: 922,
          maxWidth: '90%',
        },
        '& .MuiDialogContent-root': {
          padding: 0,
        },
      }}
    >
      <DialogContent>
        <MainContainer>
          <CloseButton onclickFn={closeWelcomeOnboarding} />
          <WelcomeUser>Welcome, {getUserName()}</WelcomeUser>
          <Navbar>
            {navItems.map((item) => (
              <NavbarButton
                key={item}
                isActive={activeOnboarding === item}
                onClick={() => setActiveOnboarding(item)}
              >
                {item}
              </NavbarButton>
            ))}
          </Navbar>
          <div>{handleActiveOnboarding()}</div>
          <StopShowCheckBox>
            <CheckboxBordered
              type="checkbox"
              checked={stopShowing}
              disabled={togglePending}
              onChange={handleStopShowingToggle}
            />
            <span style={{ marginLeft: '8px' }}>Stop showing me this</span>
          </StopShowCheckBox>
        </MainContainer>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeOnboarding;
